import { ComponentOptions } from '../types';
import { componentVendorData } from './component-vendor.data';
import { ComponentVendorData, ComponentVendorDataIn } from './types';

export class ComponentVendor {
	#id: string;

	readonly displayValue: string;

	public active: boolean;
	public description: string;

	constructor (options: ComponentOptions<ComponentVendorDataIn>) {
		const data = componentVendorData(options);

		this.#id = data.id;
		this.displayValue = data.displayValue;
		this.description = data.description;
		this.active = data.active;
	}

	get id (): string { return this.#id }

	public serialize ():ComponentVendorData {
		return {
			id: this.#id,
			displayValue: this.displayValue,
			description: this.description,
			active: this.active
		};
	}
}
